import { render, staticRenderFns } from "./Recursive.vue?vue&type=template&id=07276f23&scoped=true"
import script from "./Recursive.vue?vue&type=script&lang=js"
export * from "./Recursive.vue?vue&type=script&lang=js"
import style0 from "./Recursive.vue?vue&type=style&index=0&id=07276f23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07276f23",
  null
  
)

export default component.exports